import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";

import Home from "./pages/Home";
import About from "./pages/About";
import Careers from "./pages/Careers";
import Contact from "./pages/Contact";
import AdminPanel from "./Admin/Adminpanel";
import AdminLogin from "./Admin/Adminlogin";
import ProtectedRoute from "./Admin/ProtectedRoute";

export default function App() {
  return (
    <BrowserRouter>
      <div className="bg-[#F5F7FB] dark:bg-[#050816] text-[#0A0F1C] dark:text-white min-h-screen transition-colors">
        <Navbar />

        {/* Page Content */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin-login" element={<AdminLogin />} />

          <Route
            path="/admin"
            element={
            <ProtectedRoute>
            <AdminPanel />
            </ProtectedRoute>
          }
/>


        </Routes>

        {/* Footer MUST be outside Routes */}
        <Footer />
      </div>
    </BrowserRouter>
  );
}
